export default __webpack_public_path__ + "static/media/Mobile_Hero_03.ac69518d.jpeg";